var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgendaComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1946 4.53694L6.87007 7.86145L5.80713 6.79851C5.15127 6.14266 4.06572 6.14266 3.40986 6.79851C2.754 7.45437 2.754 8.53993 3.40986 9.19578L5.67144 11.4574C6.01067 11.7966 6.44037 11.9549 6.87007 11.9549C7.29977 11.9549 7.72947 11.7966 8.06871 11.4574L12.5919 6.93421C13.2477 6.27835 13.2477 5.19279 12.5919 4.53694C11.936 3.88108 10.8504 3.88108 10.1946 4.53694Z",
    fill: "#66D16F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaComplete);
export default __webpack_public_path__ + "static/media/agenda-complete.5b149f341e08e590b5b02ea6bc50b263.svg";
export { ForwardRef as ReactComponent };